import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  card: {
    display: 'flex',
    margin: '16px',
    width: '900px',
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,
    flexDirection: 'column',
  },

  title: {
    padding: '0 16px',
  },

  right: {
    padding: '16px',
  },

  cont: {
    height: 'calc(100vh - 300px)',
    overflowY: 'auto',
    [theme.breakpoints.down('932')]: {
      '&': {
        height: 'calc(100vh - 224px)',
      },
    },
  },

  skelets: {
    paddingTop: '16px',
    '& > *': {
      marginBottom: '16px',
      borderRadius: '5px',
    },
  },

  paper: {
    height: '100%',
  },

  menuItem: {
    padding: '20px 20px',
    '&.Mui-selected': {
      backgroundColor: '#2196f3',
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: '#2196f3',
      },
    },
  },

  menuItemActive: {
    backgroundColor: '#2196f3',
  },

  menuTitle: {
    fontSize: '20px',
    marginLeft: '5px',
  },

  cardHeader: {
    paddingRight: '0',
    paddingLeft: '0',
    color: '#2196f3',
    borderBottom: '1px solid',
  },

  icon: {
    verticalAlign: 'middle',
  },
}))
